import React from 'react';
import { Button, CircularProgress, MenuItem, Select, TextField } from '@mui/material';
import { useMaterialsStore } from '../../Stores/MaterialsStore';
import { useInventoryReports } from '../../../hooks/useInventoryReports';
import { useFutureOrders } from '../../../hooks/useFutureOrders';
import { updateUserAccount } from '../../../sp-firebase/userFB';
import { useUser } from '../../../hooks/useUser';
import { useAccountStore } from '../../Stores/accountStore';
import { getAccounts } from '../../../sp-firebase/accountFB';

interface AdminButtonsProps {
  accountId: string;
  userId: string;
}
export const AdminButtons: React.FC<AdminButtonsProps> = ({ accountId }) => {
  const { account } = useAccountStore();

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedAccount, setSelectedAccount] = React.useState('');
  const [accounts, setAccounts] = React.useState<string[]>([]);

  const { refetch: refetchFutureOrders } = useFutureOrders();
  const { refetch: refetchInventoryReports } = useInventoryReports();
  const { data: userData, refetch: refetchUser } = useUser();

  const refetchAll = () =>
    Promise.all([refetchFutureOrders(), refetchInventoryReports()]).then(() => setIsLoading(false));

  const getAllAccounts = async () => {
    setIsLoading(true);

    const allAccounts = await getAccounts();

    setAccounts(allAccounts?.map(({ id }) => id || '') || []);
    setSelectedAccount(allAccounts?.[0]?.id || '');

    setIsLoading(false);
  };

  React.useEffect(() => {
    getAllAccounts();
  }, [account]);

  const switchAccount = async () => {
    setIsLoading(true);

    await updateUserAccount(userData?.id || '', selectedAccount);

    await refetchUser();
    refetchAll();
    window.location.reload();
  };

  return (
    <div className="flex flex-row gap-2 h-9 border p-1">
      {selectedAccount && (
        <Select label="Account" value={selectedAccount}>
          {accounts?.map((account, i) => (
            <MenuItem key={i} id={account} value={account} onClick={() => setSelectedAccount(account)}>
              {account}
            </MenuItem>
          ))}
        </Select>
      )}
      -&gt;
      <Button
        title={`current accountId: ${accountId}`}
        size="small"
        onClick={switchAccount}
        className="relative flex m-0"
        variant="contained"
        disabled={isLoading || accountId === selectedAccount}
      >
        {isLoading && <CircularProgress size={24} className="absolute align-middle justify-center" />}
        Switch to:&nbsp;<b> {selectedAccount}</b>
      </Button>
    </div>
  );
};
